function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-delete_svg__clip0)",
  fill: "#879097"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.5 17.5C2.5 18.878 3.621 20 5 20h10c1.379 0 2.5-1.122 2.5-2.5V5h-15v12.5zM12.5 1.25V0h-5v1.25H1.25v2.5h17.5v-2.5H12.5z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-delete_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgIconDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconDelete;